import React from 'react';
import { Box } from '@mui/material';
import DealListSearch from '@pages/Pages/components/DealListSearch';

const SearchComponent = ({
  visualFilter,
  setVisualFilter,
  debouncedSearch,
  clearSearch
}: {
  visualFilter: string;
  setVisualFilter: React.Dispatch<React.SetStateAction<string>>;
  debouncedSearch: (query: string) => void;
  clearSearch: () => void;
}) => {
  return (
    <>
      <Box display="inline-flex" width="100%">
        <DealListSearch
          value={visualFilter}
          onChange={(value) => {
            setVisualFilter(value);
            debouncedSearch(value);
          }}
          placeholder="Search..."
          clearFn={() => {
            clearSearch();
          }}
        />
      </Box>
    </>
  );
};

export default SearchComponent;
